import React from 'react'
import {ReactComponent} from './data-analysis.svg'
import {MergeReactElementProps} from '../types'

interface DataAnalysisProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', DataAnalysisProps>

export const DataAnalysis = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill="none" ref={ref} {...props} />
  }
)
